import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import Icon from '../../../../../../components/icon';
import Button from '../../../../../../components/button';
import {getSharingDetailsPopup, isSharing, share} from '../../../../../../../actions/sharingDetailsActions';
import {resetStates} from '../../../../../../../actions/contactsGroupItemActions';

function ConfirmDirectorySharingPopup () {

    const [isLoading, setIsLoading] = useState(false);

    const { t } = useTranslation();
    const dispatch = useDispatch();

	const cancelShare = () => {
		dispatch(getSharingDetailsPopup([]));

		/* To reset Add collaborators */
		dispatch(resetStates('exceptContacts'));
		dispatch(isSharing(false));
    };

	const confirmShare = () => {
		setIsLoading(true);
		dispatch(share());
	};

	return (
		<div className="p-4">
			<h2 className="text-warning pr-5"><Icon className="mr-2" name="warning"/>{t("warning")}</h2>
			<p>{t('confirmDirectorySharingPopupMessage')}</p>
			<div className="text-right">
				<Button className="btn-link" disabled={isLoading} onClick={ cancelShare }>
					{t("noText")}
				</Button>
				{
					isLoading === false
						?
						<Button className="btn-primary" onClick={ confirmShare }>
							{t("yesText")}
						</Button>
						:
						<Button className="btn-primary" disabled={true}>
							<Icon animated={'pulse'} name="spinner"/>
						</Button>
				}
			</div>
		</div>
	);
}

export default ConfirmDirectorySharingPopup;
